import React, { useContext, useEffect } from 'react';
import { Box, Text, Colors } from '@tapresearch/ui/components';
import { AccordionPanel, AccordionItem, AccordionButton, AccordionIcon, useAccordionItemState } from '@chakra-ui/react';
import { filterContext } from '../FilterProvider';
export function FilterAccordionItem(props) {
    var title = props.title, children = props.children, filterName = props.filterName;
    var filterValues = useContext(filterContext).filterValues;
    var filterValue = filterValues[filterName];
    var filtersApplied = Array.isArray(filterValue) ? filterValue.length : filterValue !== undefined ? 1 : undefined;
    // const { onOpen } = useAccordionItem({ id: filterName });
    return /*#__PURE__*/ React.createElement(AccordionItem, {
        id: "".concat(filterName, "-accordion-item")
    }, function(param) {
        var isExpanded = param.isExpanded;
        return /*#__PURE__*/ React.createElement(FilterAccordionContent, {
            filterName: filterName,
            title: title,
            isExpanded: isExpanded,
            filtersApplied: filtersApplied
        }, children);
    });
}
function FilterAccordionContent(param) {
    var isExpanded = param.isExpanded, filtersApplied = param.filtersApplied, filterName = param.filterName, children = param.children, title = param.title;
    var onOpen = useAccordionItemState().onOpen;
    useEffect(function() {
        if (filtersApplied && !isExpanded) {
            onOpen();
        }
    }, [
        filtersApplied,
        onOpen,
        isExpanded
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h2", null, /*#__PURE__*/ React.createElement(AccordionButton, {
        "data-testid": "".concat(filterName, "-filter-accordion-button").concat(isExpanded ? '-opened' : ''),
        paddingTop: '6',
        paddingX: '6',
        paddingBottom: '6',
        fontSize: 'lg',
        fontWeight: 'bold',
        outline: 'none',
        _focus: {
            outline: 'none'
        },
        _hover: {
            bgColor: 'none'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        flex: "1",
        textAlign: "left"
    }, title), filtersApplied > 0 && /*#__PURE__*/ React.createElement(Text, {
        mr: "3",
        fontSize: "sm",
        color: Colors.gray[500]
    }, "Targets: ", filtersApplied), /*#__PURE__*/ React.createElement(AccordionIcon, null))), /*#__PURE__*/ React.createElement(AccordionPanel, {
        "data-testid": "".concat(filterName, "-filter-accordion-panel"),
        px: "6",
        paddingTop: "0",
        paddingBottom: "6"
    }, children));
}
